import {makeAutoObservable, runInAction} from "mobx";
import type {MithraMaterializedApi} from "../../services/MithraMaterializedApi";

export class InsightsJobManager {
    already_running?: boolean;

    constructor(private api: MithraMaterializedApi) {
        makeAutoObservable(this);
    }

    updateRunningCount() {
        this.api.getInsightsJobRunning().then((response) => {
            if (response.status === 200)
                runInAction(() => {
                    this.already_running = response.data.gcp_running > 0;
                });
            if (this.already_running)
                setTimeout(() => {
                    this.updateRunningCount();
                }, 30000);
        }).catch(() => {
            if (this.already_running)
                setTimeout(() => {
                    this.updateRunningCount();
                }, 30000);
        });
    }

    createRecalculation() {
        this.api.createInsightsJon().then((response) => {
            if (response.status === 201)
                runInAction(() => {
                    this.already_running = true;
                });
        }).catch((response) => {
            if (response.status === 400) {
                runInAction(() => {
                    this.already_running = false;
                });
            }
        }).finally(() => {
            if (this.already_running)
                setTimeout(() => {
                    this.updateRunningCount();
                }, 30000);
        })
    }
}
